import React from 'react';

function CartIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='48'
			height='48'
			viewBox='0 0 48 48'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_1357_45414)'>
				<path
					d='M20.7776 41.7632L8.2336 8.66243H0V5.45923H10.4416L22.6368 37.6352L47.4336 28.2368L48.5664 31.2288L20.7776 41.7632Z'
					fill='#212121'
				/>
				<path
					d='M37.8659 3.43359L15.3604 11.968L23.8947 34.4832L46.4003 25.952L37.8659 3.43359ZM27.306 26.9728L22.7972 15.0848L24.5732 14.4L28.4995 24.7712L30.3555 24.0672L30.9347 25.6L27.306 26.9728ZM35.8723 23.7248L33.2388 18.3328C32.9188 17.6928 32.6691 17.1552 32.4132 16.608C32.5795 17.1776 32.7331 17.7472 32.9347 18.448L34.5347 24.2368L32.5795 24.9792L26.5956 13.648L28.3684 12.976L31.3603 19.0016C31.5588 19.408 31.7316 19.7696 31.8979 20.1248C31.7796 19.7344 31.6707 19.3504 31.5555 18.928L29.7828 12.4384L31.6291 11.7376L34.6116 17.7696C34.8099 18.1824 34.9891 18.5568 35.1619 18.9344C35.0435 18.5344 34.9315 18.1376 34.8099 17.696L33.0532 11.2L34.778 10.56L37.8467 22.9888L35.8723 23.7248Z'
					fill='#212121'
				/>
				<path
					d='M21.7186 47.7248C24.3289 47.7248 26.445 45.6087 26.445 42.9984C26.445 40.3881 24.3289 38.272 21.7186 38.272C19.1083 38.272 16.9922 40.3881 16.9922 42.9984C16.9922 45.6087 19.1083 47.7248 21.7186 47.7248Z'
					fill='#212121'
				/>
			</g>
			<defs>
				<clipPath id='clip0_1357_45414'>
					<rect width='48' height='48' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
}

export default CartIcon;
